module.exports = __webpack_public_path__ + "1141fe039f67eb5174308d6d919dfef0.png";